module.exports = __webpack_public_path__ + "media/images/number_3-3e013b17e39c4be148cb9ea38dd0cd3d.png";